import { useCallback, useEffect, useRef } from "react";

import { webSocketWorker } from "../../workers";

export function useWebSocketWorkerMessage(fn?) {
  const cb = useRef(fn);

  const sendMessage = useCallback((messageObject) => {
    webSocketWorker.postMessage(messageObject);
  }, []);

  const terminateWorker = useCallback(() => {
    webSocketWorker.terminate();
  }, []);

  useEffect(() => {
    const onMessage = cb.current;

    webSocketWorker.addEventListener("message", onMessage);

    return () => {
      webSocketWorker.removeEventListener("message", onMessage);
    };
  }, []);

  return {
    sendMessage,
    terminateWorker,
  };
}
